import { mount } from "@vue/test-utils";
import InstagramImage from "@/components/core/InstagramImage";

describe("InstagramImage test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(InstagramImage);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component InstagramImage", () => {
    expect(wrapper).toBeDefined();
  });
});
